import React from 'react';
import { Link } from 'react-router-dom';
import { Img, ScrollRow, Section, Shimmer } from '@/components/ui';
import { useArtists } from '@/hooks/useCatalog';

/**
 * "Artists on LocalKonnect" — round portraits, District-style. Artists and
 * their event lineups are managed in LK Admin → Catalog → Artists; the list
 * only includes artists with an event on the platform (or marked featured).
 */
const ArtistTile = ({ artist }) => {
  const line =
    artist.upcomingCount > 0
      ? `${artist.upcomingCount} upcoming`
      : artist.pastCount > 0
        ? `${artist.pastCount} past event${artist.pastCount === 1 ? '' : 's'}`
        : artist.tagline || '';
  return (
    <Link to={`/artist/${artist.slug}`} className="lk-focus group block w-28 rounded-2xl text-center sm:w-36">
      <Img
        src={artist.photo}
        alt={artist.name}
        label={artist.name}
        className="mx-auto aspect-square w-28 overflow-hidden rounded-full ring-1 ring-ink-200 sm:w-36"
        imgClassName="transition-transform duration-500 group-hover:scale-105"
      />
      <p className="mt-3 line-clamp-2 text-sm font-semibold leading-tight text-ink-900">{artist.name}</p>
      {line && <p className="mt-0.5 line-clamp-1 text-xs text-ink-500">{line}</p>}
    </Link>
  );
};

const ArtistsRail = ({ title = 'Artists on LocalKonnect', subtitle = 'Tap an artist to see their upcoming and past shows' }) => {
  const { artists, loading } = useArtists(30);

  if (!loading && artists.length === 0) return null;

  return (
    <Section title={title} subtitle={subtitle}>
      {loading ? (
        <div className="flex gap-5 overflow-hidden">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="w-28 shrink-0 sm:w-36">
              <Shimmer className="aspect-square w-full rounded-full" />
              <Shimmer className="mx-auto mt-3 h-4 w-3/4 rounded" />
            </div>
          ))}
        </div>
      ) : (
        <ScrollRow>
          {artists.map((artist) => (
            <ArtistTile key={artist.id} artist={artist} />
          ))}
        </ScrollRow>
      )}
    </Section>
  );
};

export default ArtistsRail;
